import { FC, useEffect, useMemo } from 'react'
import { Box, Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { FormItem } from 'components'
import { COST_CENTER_INITIAL_FILTER_FIELDS } from 'InstitutionalManagement/constants/pages/costCenters'
import { CostCenterFieldsName, CostCenterFilterKeyString } from 'InstitutionalManagement/types'
import { STATUS_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  hasPrefix?: boolean
  isOpen?: boolean
  register: UseFormRegister<CostCenterFilterKeyString>
  onlyFields?: CostCenterFieldsName[]
}

const CostCenterFilterForm: FC<Props> = ({ hasPrefix, isOpen = false, register, onlyFields }) => {
  const costCenterFilterFields = useMemo(() => {
    return onlyFields || COST_CENTER_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key: CostCenterFieldsName) {
    if (hasPrefix) return `cost_center_${key}`
    return key
  }

  useEffect(() => {
    focusElementById('name')
  }, [isOpen])

  return (
    <Box>
      {costCenterFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {costCenterFilterFields.includes('name') && (
        <FormItem label="Nome" htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {costCenterFilterFields.includes('description') && (
        <FormItem label="Descrição" htmlFor="description">
          <Input id="description" {...register(setPrefix('description'))} />
        </FormItem>
      )}
      {costCenterFilterFields.includes('status') && (
        <FormItem label="Status" htmlFor="status">
          <Select id="status" {...register(setPrefix('status'))}>
            {STATUS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
    </Box>
  )
}

export default CostCenterFilterForm
